import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import { getMessageUser, haveReadMessage } from '@/api/message';
import ShowMessage from './ShowMessage.vue';
import DownloadIfram from './DownloadIfram.vue';
import { valsubstr32addbr, saveFile } from '@/utils/index';
import NoData from '@/components/NoData/NoData';
import { fmtReqParams, query } from './index';
import delDialog from '@/components/System/DelDialog';
export default {
  name: 'MessageNotice',
  components: {
    SearchForm: SearchForm,
    ShowMessage: ShowMessage,
    DownloadIfram: DownloadIfram,
    NoData: NoData,
    delDialog: delDialog
  },
  filters: {
    messageStateFilter: function messageStateFilter(state) {
      var messageStateMap = {
        UNREAD: '未读',
        HAVE_READ: '已读'
      };
      return messageStateMap[state];
    }
  },
  props: {
    systemModuleArr: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    systemModuleMap: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      loading: false,
      selectedArr: [],
      todoTitle: '消息通知',
      messageFormData: [{
        title: '系统名称',
        key: 'systemId',
        placeholder: '请选择系统名称',
        multiple: true,
        type: 'select',
        value: null,
        selectData: JSON.parse(localStorage.getItem('SYSTEM_NAME_ARR')),
        selectedArr: null
      }, {
        title: '消息起止时间',
        key: 'date',
        placeholder: '请选择(当月/当季/上季度)',
        type: 'date2',
        value: [],
        selectData: [],
        selectedArr: []
      }, {
        title: '消息状态',
        key: 'messageStates',
        placeholder: '请选择消息状态',
        type: 'select',
        selectData: [{
          value: 'UNREAD',
          label: '未读'
        }, {
          value: 'HAVE_READ',
          label: '已读'
        }],
        selectedArr: ['UNREAD'],
        multiple: true
      }],
      messageList: [],
      searchReq: query('messageStates'),
      total: 0,
      delChecked: false,
      isIndeterminate: false,
      multipleSelection: [],
      delmessagelist: [],
      ifShowDelDialog: false,
      showdownload: false,
      showdownloadurl: '',
      showmessage: false,
      showmessageurl: '',
      systemlist: JSON.parse(localStorage.getItem('SYSTEM_NAME_ARR')),
      showDialog: false,
      dialogUrl: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    window.addEventListener('message', function (e) {
      var data = JSON.parse(e.data);
      if (data.type === 'CLOSEDOWNMODAL') {
        _this.showdownload = false;
        _this.loading = false;
      }
    });
    this.searchForm();
  },
  computed: {},
  methods: {
    // 选择系统名称
    changeSelect: function changeSelect(_ref) {
      var key = _ref.key,
        selectedArr = _ref.selectedArr;
      if (key === 'systemId') {
        this.messageFormData[1].selectedArr = null;
        var systemModuleMap = this.systemModuleArr.find(function (_ref2) {
          var systemId = _ref2.dictGroup.systemId;
          return systemId === selectedArr;
        });
        this.messageFormData[1].selectData = systemModuleMap ? systemModuleMap.detailList.map(function (_ref3) {
          var dictCode = _ref3.dictCode,
            dictName = _ref3.dictName;
          return {
            label: dictCode,
            value: dictName
          };
        }) : [];
      }
    },
    // 点击table某行 => 已读消息
    rowClick: function rowClick(_ref4) {
      var _this2 = this;
      var id = _ref4.id,
        url = _ref4.url,
        messageState = _ref4.messageState,
        urlType = _ref4.urlType,
        systemId = _ref4.systemId;
      if (messageState === 'UNREAD') {
        haveReadMessage(id).then(function (res) {
          if (res.code === '0000000000') {
            _this2.$emit('refreshMessage');
            _this2.searchForm();
          }
        });
      }
      if (url == null || url === '' || url === undefined) {
        return;
      }
      switch (urlType) {
        case 'DOWNLOAD':
          // eslint-disable-next-line no-lone-blocks
          {
            //              this.showmessage = false
            //              this.showdownload = true
            // //           var myframe = document.getElementById('myframe');//获取iframe
            //              this.showdownloadurl = url
            // let downloadurl = url.split('sz.bocsys.cn/')[1]
            // this.$API.getRequest({url: downloadurl,responseType:'blob'}).then((res)=>{
            //   if(res.headers['content-disposition']){
            //     let fileName = window.decodeURI(res.headers['content-disposition'])
            //     let finannlname = fileName.split('"')[1];
            //     const elink = document.createElement("a");
            //     // console.log(new Blob([v.data]));
            //     elink.href = window.URL.createObjectURL(new Blob([res.data]));
            //     elink.style.display = 'none';
            //     elink.setAttribute('download', finannlname);
            //     document.body.appendChild(elink);
            //     elink.click();
            //     URL.revokeObjectURL(elink.href); // 释放URL 对象
            //     document.body.removeChild(elink);
            //       // loading.close();
            //   }
            //  })
            // popup.close();
            this.$message({
              message: '开始下载',
              type: 'warning'
            });
            this.loading = true;
            // let filePath = url.split('filePath=')[1]
            // this.$API.getRequest({
            //   url:'/platform/file//templateDownload',
            //   data:{
            //     filePath
            //   },
            //   responseType:'blob'
            // }).then((res)=>{
            //     if(res.headers['content-disposition']){
            //       let fileName = window.decodeURI(res.headers['content-disposition'])
            //       let finannlname = fileName.split('"')[1];
            //       const elink = document.createElement("a");
            //       // console.log(new Blob([v.data]));
            //       elink.href = window.URL.createObjectURL(new Blob([res.data]));
            //       elink.style.display = 'none';
            //       elink.setAttribute('download', finannlname);
            //       document.body.appendChild(elink);
            //       elink.click();
            //       URL.revokeObjectURL(elink.href); // 释放URL 对象
            //       document.body.removeChild(elink);
            //       this.loading = false
            //     }
            // })
            if (systemId === 'LC_PLATFORM') {
              this.$API.getRequest({
                url: '/platform/file/templateDownload',
                data: {
                  filePath: url.split('filePath=')[1]
                },
                responseType: 'blob'
              }).then(function (res) {
                _this2.loading = false;
                var fileName = window.decodeURI(res.headers['content-disposition']);
                saveFile(res.data, fileName.split('filename=')[1]);
              }).catch(function () {
                _this2.$message.warning('文件已过期,请重新生成！');
              });
            } else {
              this.showdownload = true;
              this.showmessage = false;
              this.showdownloadurl = url;
            }
          }
          break;
        case 'NOT_JUMP':
          // eslint-disable-next-line no-lone-blocks
          {
            /* empty */
          }
          break;
        case 'JUMP':
          // eslint-disable-next-line no-lone-blocks
          {
            this.$store.dispatch('settings/changeSetting', {
              key: 'iframeUrl',
              value: url
            });
          }
          break;
        case 'POPUP':
          // eslint-disable-next-line no-lone-blocks
          {
            this.showdownload = false;
            this.showmessage = true;
            this.showmessageurl = url;
          }
          break;
        case 'DIALOG':
          // eslint-disable-next-line no-lone-blocks
          {
            this.showDialog = true;
            this.dialogUrl = url;
          }
          break;
        case 'NEW_PAGE':
          // eslint-disable-next-line no-lone-blocks
          {
            window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(window.encodeURIComponent(url))));
          }
          break;
        default:
          break;
      }
      // const jumpUrl = `${url}?access_toke=${getToken()}`
      // url && window.open(jumpUrl)
    },
    // 全选
    selectAll: function selectAll(checked) {
      var _this3 = this;
      if (checked) {
        this.messageList.forEach(function (ele) {
          _this3.$refs.multipleTable.toggleRowSelection(ele, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      this.isIndeterminate = false;
    },
    // 显示删除弹框
    showdeldialog: function showdeldialog() {
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.ifShowDelDialog = true;
      } else {
        this.$message({
          message: '请选择删除项',
          type: 'warning'
        });
      }
    },
    delteMessage: function delteMessage() {
      var _this4 = this;
      this.ifShowDelDialog = false;
      this.delmessagelist = [];
      // eslint-disable-next-line array-callback-return
      this.multipleSelection.filter(function (item) {
        _this4.delmessagelist.push(item.id);
      });
      // if((this.filtratedata.pageNum == Math.ceil(this.totalrecord/this.filtratedata.pageSize) &&  (this.totalrecord%this.filtratedata.pageSize == this.dellist.length || this.totalrecord%this.filtratedata.pageSize == 0 ))){
      //   this.filtratedata.pageNum > 1 ? this.filtratedata.pageNum-- :this.filtratedata.pageNum = 1
      // }
      this.delMessageDialog();
    },
    delMessageDialog: function delMessageDialog() {
      var _this5 = this;
      this.$API.delRequest({
        url: '/platform/message/delete',
        data: this.delmessagelist
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.$message({
            message: '删除消息成功',
            type: 'success'
          });
          _this5.getMessageUserList(_this5.searchReq);
        }
      });
    },
    selectionChange: function selectionChange(val) {
      var checkedCount = val.length;
      this.delChecked = checkedCount === this.messageList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.messageList.length;
      this.multipleSelection = val;
      this.selectedArr = val;
    },
    searchForm: function searchForm() {
      this.searchReq = fmtReqParams(this.messageFormData, this.searchReq);
      this.getMessageUserList(this.searchReq);
    },
    getMessageUserList: function getMessageUserList(searchReq) {
      var _this6 = this;
      this.loading = true;
      getMessageUser(searchReq).then( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          var code, _res$result, list, total;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  code = res.code, _res$result = res.result, list = _res$result.list, total = _res$result.total;
                  if (!(code === '0000000000')) {
                    _context.next = 6;
                    break;
                  }
                  _context.next = 4;
                  return _this6.$nextTick();
                case 4:
                  // eslint-disable-next-line no-return-assign
                  list.forEach(function (item) {
                    return item.systemModule = _this6.systemModuleMap[item.systemModule];
                  });
                  Object.assign(_this6, {
                    messageList: list,
                    total: total
                  });
                case 6:
                  _this6.loading = false;
                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref5.apply(this, arguments);
        };
      }()).catch(function () {
        _this6.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.messageFormData.forEach(function (item) {
        if (item.key === 'systemModule') item.selectData = [];
        item.selectedArr = item.key === 'messageStates' ? [] : null;
        item.value = Array.isArray(item.value) ? [] : null;
      });
    },
    onSizeChange: function onSizeChange(pageSize) {
      this.searchReq.pageSize = pageSize;
      this.searchForm();
    },
    onCurrentChange: function onCurrentChange(pageNum) {
      this.searchReq.pageNum = pageNum;
      this.searchForm();
    },
    // tooltips过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    getsystemname: function getsystemname(val) {
      var systemname = null;
      // eslint-disable-next-line array-callback-return
      this.systemlist.filter(function (ele) {
        if (ele.value === val) {
          systemname = ele.label;
        }
      });
      return systemname;
    }
  }
};